function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.44,240a242.59,242.59,0,0,0-130-168.47Q331.86,66.29,320,61c-99-44-156-6-185,38S70,219,47,256-6,371,52,425s113,36,151,21,76-2,146-2,128-54,132-121C482.46,298.48,478.3,268.33,472.44,240Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.44,240a242.59,242.59,0,0,0-130-168.47Q331.86,66.29,320,61c-99-44-156-6-185,38S70,219,47,256-6,371,52,425s113,36,151,21,76-2,146-2,128-54,132-121C482.46,298.48,478.3,268.33,472.44,240Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lock--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.83,256.8A102.38,102.38,0,0,0,165.72,239",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,282.55a103.45,103.45,0,0,0-1.31-14.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.37,338.64A102.36,102.36,0,0,0,359,296.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.88,326.43c1,2.21,2.06,4.39,3.2,6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,247.38a102.74,102.74,0,0,0-1.09,71.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,305.38a73.66,73.66,0,0,0,2.23-10.32l-4.87-.51a2.5,2.5,0,1,1,.52-5l4.87.51c.13-1.79.22-3.6.22-5.42a73.4,73.4,0,0,0-2.84-20.23l-5,1.62a2.63,2.63,0,0,1-.77.12,2.5,2.5,0,0,1-.77-4.88l5-1.63a73.58,73.58,0,0,0-13-22.45l-4.13,3.72a2.5,2.5,0,0,1-1.67.64,2.47,2.47,0,0,1-1.86-.82,2.5,2.5,0,0,1,.18-3.53l4.13-3.72a73.8,73.8,0,0,0-21.09-15.26l-2.35,5.29a2.51,2.51,0,0,1-2.29,1.48,2.42,2.42,0,0,1-1-.22,2.5,2.5,0,0,1-1.27-3.3l2.34-5.25A73.53,73.53,0,0,0,259.1,211v5.81a2.5,2.5,0,1,1-5,0v-5.77a73.34,73.34,0,0,0-25.44,5.71L231,222a2.5,2.5,0,0,1-1.27,3.3,2.42,2.42,0,0,1-1,.22,2.51,2.51,0,0,1-2.29-1.48l-2.3-5.17a73.88,73.88,0,0,0-20.77,15.64l4.08,3.67a2.5,2.5,0,0,1-1.67,4.36,2.47,2.47,0,0,1-1.67-.65l-4-3.61A73.85,73.85,0,0,0,187.58,261l4.92,1.59a2.5,2.5,0,0,1-.77,4.88,2.64,2.64,0,0,1-.78-.12l-4.82-1.57a73.71,73.71,0,0,0-2.46,18.91c0,2.27.12,4.51.32,6.73l4.77-.5a2.5,2.5,0,0,1,.52,5l-4.68.5A73,73,0,0,0,193,320.53l3.87-2.23a2.5,2.5,0,0,1,2.5,4.33l-3.78,2.18a74,74,0,0,0,17.35,18.63l2.47-3.4a2.5,2.5,0,0,1,4,2.94L217,346.32a73.42,73.42,0,0,0,23.32,10l.85-4a2.5,2.5,0,0,1,4.89,1l-.84,3.94a73.47,73.47,0,0,0,25.36-.21l-.85-4a2.5,2.5,0,1,1,4.89-1l.85,4a73.44,73.44,0,0,0,23.18-10.42l-2.51-3.45a2.5,2.5,0,1,1,4-2.94l2.49,3.43a74.19,74.19,0,0,0,17.08-18.94l-3.93-2.27a2.5,2.5,0,1,1,2.5-4.33l4,2.28a73.9,73.9,0,0,0,4.21-9.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.57,260.73a49,49,0,1,0,4.52-6.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.21,116.91a56.34,56.34,0,0,1,109.46,18.76v27.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,203.1V135.67a74.34,74.34,0,1,0-148.67,0v78.67a102.6,102.6,0,0,1,18-15.11V135.67a56.25,56.25,0,0,1,1.3-12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.67,172.8v26.43a102.6,102.6,0,0,1,18,15.11v-7.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Password--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.67,440.33H188a13.67,13.67,0,0,1-13.67-13.66h0A13.67,13.67,0,0,1,188,413H326.67a13.67,13.67,0,0,1,13.66,13.67h0A13.67,13.67,0,0,1,326.67,440.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.85,425.17l-1.28-8.12H196l-1.28,8.12,7.34-3.69,1.38,4.19L195.36,427l5.76,5.76-3.54,2.61-3.79-7.28L190,435.41l-3.55-2.61,5.76-5.76-8.07-1.37,1.38-4.19Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.73,425.17l-1.28-8.12h4.43l-1.28,8.12,7.34-3.69,1.38,4.19L227.24,427,233,432.8l-3.54,2.61-3.79-7.28-3.79,7.28-3.55-2.61,5.76-5.76L216,425.67l1.37-4.19Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.61,425.17l-1.28-8.12h4.43l-1.28,8.12,7.34-3.69,1.38,4.19L259.12,427l5.76,5.76-3.54,2.61-3.79-7.28-3.8,7.28-3.54-2.61L256,427l-8.08-1.37,1.38-4.19Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.49,425.17l-1.28-8.12h4.43l-1.28,8.12,7.34-3.69,1.38,4.19L291,427l5.76,5.76-3.54,2.61-3.8-7.28-3.79,7.28-3.54-2.61,5.76-5.76-8.08-1.37,1.38-4.19Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.37,425.17l-1.28-8.12h4.43l-1.28,8.12,7.34-3.69,1.37,4.19L322.88,427l5.76,5.76-3.55,2.61-3.79-7.28-3.79,7.28L314,432.8l5.76-5.76-8.08-1.37,1.38-4.19Z",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--GPS--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 393.22,
    x2: 381.5,
    y2: 393.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.62,325V347.9A9.08,9.08,0,0,0,435.7,357H438a8.9,8.9,0,0,1,8.9,8.91v16.77a10.55,10.55,0,0,1-10.55,10.55H423.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,339.93h3.47a10,10,0,0,0,10-10v-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.37,324.66v7.1h3.89a10.68,10.68,0,0,1,10.67,10.68v1.4h5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.14,
    y1: 331.76,
    x2: 383.98,
    y2: 331.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.37,
    y1: 331.76,
    x2: 397.42,
    y2: 331.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 435.14,
    y1: 393.58,
    x2: 435.14,
    y2: 414.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.58,
    y1: 374.04,
    x2: 458.59,
    y2: 374.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "453.61 374.04 453.61 366.22 459.3 366.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.89,
    y1: 342.42,
    x2: 460.01,
    y2: 342.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "442.96 359.23 442.96 342.42 449.62 342.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.92,404.94l10.3-7.46h23.09a7.46,7.46,0,0,1,7.46,7.46v8.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.91,
    y1: 389.79,
    x2: 454.91,
    y2: 413.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "430.85 382.67 446.87 382.67 454.91 382.67 454.91 384.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.03,
    y1: 382.67,
    x2: 426.16,
    y2: 382.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.16,382.85l-1.52-3.48a10.37,10.37,0,0,0-9.5-6.21H387.09v19.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460.36,
    y1: 401.01,
    x2: 422.81,
    y2: 401.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.56,365.89a3.64,3.64,0,1,0-3.64,3.63A3.63,3.63,0,0,0,438.56,365.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.54,
    y: 404.04,
    width: 22.41,
    height: 6.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.77,339.28A17.75,17.75,0,0,0,389,357c0,9.8,17.75,31.87,17.75,31.87s17.75-22.07,17.75-31.87A17.75,17.75,0,0,0,406.77,339.28Zm0,23.91a6.16,6.16,0,1,1,6.16-6.16A6.16,6.16,0,0,1,406.77,363.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.14,336.86a17.75,17.75,0,0,0-17.75,17.75c0,9.8,17.75,31.87,17.75,31.87s17.74-22.07,17.74-31.87A17.75,17.75,0,0,0,403.14,336.86Zm0,23.9a6.16,6.16,0,1,1,6.16-6.15A6.15,6.15,0,0,1,403.14,360.76Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "464.65 299 475.94 247.24 448.65 247.24 464.65 299",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.1,
    y: 203.1,
    width: 66.35,
    height: 72.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 198.76,
    width: 66.35,
    height: 72.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.71,
    y: 207.13,
    width: 16.94,
    height: 18.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.71,
    y1: 207.71,
    x2: 454.29,
    y2: 207.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 207.71,
    x2: 432.61,
    y2: 207.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.86,
    y1: 214.29,
    x2: 454.29,
    y2: 214.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 214.29,
    x2: 444.34,
    y2: 214.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.13,
    y1: 220.88,
    x2: 454.29,
    y2: 220.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 220.88,
    x2: 430.85,
    y2: 220.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440.82,
    y1: 227.47,
    x2: 454.29,
    y2: 227.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 227.47,
    x2: 434.37,
    y2: 227.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.86,
    y1: 234.06,
    x2: 454.29,
    y2: 234.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.26,
    y1: 234.06,
    x2: 441.4,
    y2: 234.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 234.06,
    x2: 427.4,
    y2: 234.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.29,
    cy: 214.01,
    r: 4.29,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,221.69a4.36,4.36,0,0,0-3.78-2.2h-4.4a4.37,4.37,0,0,0-3.55,1.84l-3,4.26h16.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.59 235.94 396.41 299 464.65 299 458.06 241.59 419.47 241.59 414.29 235.47 385.59 235.94",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.24,262.29a6.23,6.23,0,0,0-6.1-5.64,5.13,5.13,0,0,0-5.19,5.64A6.19,6.19,0,0,0,421,267.1l-.29,15.43h8.47l-2.71-15.18A5.13,5.13,0,0,0,429.24,262.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.91,123.35a.94.94,0,0,0,.91.69,1.15,1.15,0,0,0,.26,0,1,1,0,0,0,.66-1.18,25.57,25.57,0,0,0-3.21-7.12,1,1,0,0,0-1.32-.28,1,1,0,0,0-.27,1.32A23.83,23.83,0,0,1,458.91,123.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.35,114.37a1,1,0,0,0,.58.19,1,1,0,0,0,.76-.37,27.75,27.75,0,0,1,24.09-9.36c9.13,1,16.11,4,20.72,8.83a.95.95,0,1,0,1.38-1.3c-4.93-5.22-12.3-8.39-21.9-9.42A29.2,29.2,0,0,0,407.17,113,1,1,0,0,0,407.35,114.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,129.64c-5-.93-7.16-6-8.9-10.15-.4-.93-.77-1.81-1.15-2.56-2.22-4.45-11.72-9-20.64-8.26-3.77.32-16.46,2.38-21.51,15.32-2.25,5.77-2.32,12.12-2,16.44a1,1,0,0,0,.95.88h.07a1,1,0,0,0,.88-1c-.32-4.12-.25-10.17,1.86-15.6,4.65-11.91,16.41-13.81,19.91-14.11,8.74-.75,17.09,3.84,18.77,7.21.35.7.71,1.55,1.09,2.46,1.82,4.28,4.3,10.16,10.32,11.27a1,1,0,1,0,.34-1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.68,147.74l.23,0a1,1,0,0,0,.69-1.15s-.24-1-.49-2.66a1,1,0,0,0-1.09-.8.94.94,0,0,0-.79,1.08c.26,1.74.51,2.78.53,2.83A.94.94,0,0,0,408.68,147.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.64,137.54l-10.16-7.49a21.47,21.47,0,0,0-1-3.29c-1-2.86-5.45-10.52-13.24-11.6a24.86,24.86,0,0,0-13.4,1.72,1,1,0,1,0,.78,1.74A22.82,22.82,0,0,1,436,117.05c6.83.94,10.84,8,11.71,10.36a15.51,15.51,0,0,1,.94,3.17,1,1,0,0,0,.39.76l10.48,7.73a.9.9,0,0,0,.56.19,1,1,0,0,0,.57-1.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.58,143.78c-1.65-5.57-2.71-13.54,1.62-19.9a14.26,14.26,0,0,1,3.68-3.71,1,1,0,0,0-1.09-1.56,16.12,16.12,0,0,0-4.16,4.2c-3.76,5.52-4.41,13-1.88,21.51,1.72,5.8-6.57,9-6.66,9.07a1,1,0,0,0-.55,1.22,1,1,0,0,0,.89.62,1,1,0,0,0,.34-.06C411.25,153.85,417.36,149.78,415.58,143.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.85,144.75c-.1-.07-10.13-6.7-13.24-10.76-1.75-2.28-1.94-3.06-2.14-3.88a9.24,9.24,0,0,0-1.3-3c-2-3.3-6.84-6.77-13.68-5.68-6.6,1.06-10.54,6.17-10.54,13.67,0,3.09.24,5.76.47,8.35a54,54,0,0,1,.29,9.53c-.44,5.21-7.64,7.11-7.77,7.14a.95.95,0,0,0,.23,1.87l.23,0c.36-.09,8.65-2.24,9.2-8.83a55.61,55.61,0,0,0-.28-9.86c-.23-2.54-.46-5.17-.46-8.18,0-6.58,3.25-10.88,8.93-11.79,5.92-.94,10,2,11.76,4.8a7.14,7.14,0,0,1,1.07,2.49c.24,1,.49,2,2.48,4.58,3.3,4.31,13.28,10.91,13.7,11.19a1,1,0,1,0,1.05-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.38,145.2l-.48-.6c-3.68-4.58-5.7-7.1-2.7-12,1.05-1.72,2.23-2.57,3.48-2.51,1.86.07,4.05,2.11,5.59,5.18.87,1.74,3.13,4.43,6.91,8.24a1,1,0,0,0,1.35-1.35c-4.47-4.49-6-6.69-6.56-7.74-1.9-3.8-4.59-6.13-7.21-6.24-1.38-.05-3.4.49-5.18,3.43-3.7,6.07-1,9.49,2.83,14.21l.48.6c4,5,17.53,16.13,18.1,16.6a.94.94,0,0,0,.61.22,1,1,0,0,0,.6-1.69C449.06,161.41,435.26,150.05,431.38,145.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.05,145.57a1,1,0,0,0-1.31,1.38c4,3.81,7.68,7,7.72,7.05a1,1,0,0,0,.62.23.94.94,0,0,0,.72-.33,1,1,0,0,0-.09-1.34S453,149.35,449.05,145.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.93,156.77c-.13-.1-12.67-10-15.8-14.05a28.84,28.84,0,0,1-4.34-8.17.95.95,0,1,0-1.82.54,29.61,29.61,0,0,0,4.65,8.79c3.27,4.28,15.61,14,16.13,14.39a1,1,0,0,0,.59.2,1,1,0,0,0,.75-.36A1,1,0,0,0,452.93,156.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.13,160.45c-3.6,2.22-4.41,9.39-4.44,9.69a1,1,0,0,0,.85,1.05h.1a.94.94,0,0,0,.94-.85c.2-1.81,1.21-6.83,3.55-8.27,1.91-1.17,6,2.72,7.75,4.78a1,1,0,0,0,1.34.14,1,1,0,0,0,.13-1.34C441.7,164.87,436,158.09,432.13,160.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.4,149.36a1,1,0,0,0-.68,1.16,16.29,16.29,0,0,1-.71,9.14,10.61,10.61,0,0,1-5.44,6,1,1,0,0,0,.34,1.84,1,1,0,0,0,.33-.06,12.48,12.48,0,0,0,6.54-7,17.86,17.86,0,0,0,.78-10.33A1,1,0,0,0,425.4,149.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.34,99.92c5.89-1.42,14.81-2.3,23.89,1.59a.8.8,0,0,0,.37.08,1,1,0,0,0,.38-1.83c-9.56-4.09-18.92-3.18-25.09-1.69a1,1,0,1,0,.45,1.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67,102.09a1,1,0,0,0,.4-.09,26.24,26.24,0,0,1,2.48-1,1,1,0,0,0-.62-1.8,25.88,25.88,0,0,0-2.67,1,1,1,0,0,0,.41,1.81Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Email--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.88,
    y: 331.53,
    width: 71.16,
    height: 46.14,
    rx: 5.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,343.07l23.36,13.24a8.66,8.66,0,0,0,9-.26L115,337.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.88,
    y1: 337.4,
    x2: 49.95,
    y2: 340.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.08,
    y: 348.74,
    width: 71.16,
    height: 46.14,
    rx: 5.87,
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.64,
    y1: 365.99,
    x2: 132.25,
    y2: 354.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,359.6l24.54,13.92a8.66,8.66,0,0,0,9-.27l6.84-4.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.08,
    y1: 354.6,
    x2: 67.18,
    y2: 358.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.51,
    cy: 353.43,
    r: 10.56,
    transform: "translate(-246.53 336.82) rotate(-67.35)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,350.56a1.41,1.41,0,0,0,1.57-1.14h1v9.08h-1.43v-6.93h-1.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,351.6a2.17,2.17,0,1,1,4.34,0v4.72a2.17,2.17,0,1,1-4.34,0Zm1.43,4.81c0,.65.29.9.74.9s.74-.25.74-.9v-4.9c0-.65-.28-.9-.74-.9s-.74.25-.74.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cards--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.54,219.22v39a5,5,0,0,1-5,5H48.78a5,5,0,0,1-5-5v-39a5,5,0,0,1,5-5H110.5A5,5,0,0,1,115.54,219.22Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.46,
    cy: 220.79,
    r: 3.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.74,
    y: 229.77,
    width: 71.8,
    height: 11.43,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,234.71v39a5,5,0,0,1-5,5H65.28a5,5,0,0,1-5-5v-39a5,5,0,0,1,5-5H127A5,5,0,0,1,132,234.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.96,
    cy: 236.28,
    r: 3.78,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.24,
    y: 245.26,
    width: 71.8,
    height: 11.43,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.37,
    y: 109.88,
    width: 77.73,
    height: 46.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.44,
    y: 114.74,
    width: 65.59,
    height: 37.04,
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.24,
    cy: 133.26,
    r: 12.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.46,
    y: 106.36,
    width: 77.73,
    height: 46.76,
    transform: "translate(14.01 -8.4) rotate(5.99)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.54,
    y: 111.22,
    width: 65.59,
    height: 37.04,
    transform: "translate(14.01 -8.4) rotate(5.99)",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,131.07a12.75,12.75,0,1,0-14,11.35A12.75,12.75,0,0,0,100,131.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 100.25,
    width: 77.73,
    height: 46.76,
    transform: "translate(41.63 -22.12) rotate(17.57)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.58,
    y: 105.11,
    width: 65.59,
    height: 37.04,
    transform: "translate(41.63 -22.12) rotate(17.57)",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,127.48a12.75,12.75,0,1,0-16,8.31A12.77,12.77,0,0,0,104.53,127.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.35,
    cy: 164.83,
    r: 17.98,
    transform: "translate(-33.9 27.68) rotate(-12.81)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.48,
    y1: 153.54,
    x2: 92.51,
    y2: 153.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.36,
    y1: 156.27,
    x2: 90.54,
    y2: 156.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.15,
    y1: 159.76,
    x2: 89.48,
    y2: 159.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.69,
    y1: 166.89,
    x2: 88.72,
    y2: 166.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.32,
    cy: 164.83,
    r: 17.98,
    transform: "translate(-82.92 116.57) rotate(-42.52)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.32,
    cy: 164.83,
    r: 13.04,
    transform: "translate(-24.4 18.93) rotate(-8.98)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.44,157v-1.12h1.93V157c1.67.34,2.53,1.62,2.53,3.66v.47h-2.23v-.62c0-1.07-.43-1.48-1.18-1.48s-1.18.41-1.18,1.48c0,3.09,4.61,3.24,4.61,7.52,0,2-.88,3.34-2.55,3.69v1.09h-1.93v-1.09c-1.69-.35-2.55-1.65-2.55-3.69v-1h2.23v1.18c0,1.07.47,1.46,1.22,1.46s1.22-.39,1.22-1.46c0-3.08-4.61-3.23-4.61-7.52C105,158.6,105.79,157.31,107.44,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.01,
    cy: 150.15,
    r: 17.98,
    transform: "translate(-32.61 31.09) rotate(-13.81)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.14,
    y1: 138.87,
    x2: 98.17,
    y2: 138.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.02,
    y1: 141.6,
    x2: 96.2,
    y2: 141.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.8,
    y1: 145.08,
    x2: 95.14,
    y2: 145.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.35,
    y1: 152.21,
    x2: 94.38,
    y2: 152.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.98,
    cy: 150.15,
    r: 17.98,
    transform: "translate(-73.76 133.06) rotate(-47.6)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.98,
    cy: 150.15,
    r: 13.04,
    transform: "translate(-68.21 198.59) rotate(-67.69)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,142.27v-1.12H115v1.12c1.68.34,2.53,1.62,2.53,3.66v.47h-2.23v-.62c0-1.07-.42-1.48-1.17-1.48s-1.18.41-1.18,1.48c0,3.09,4.6,3.24,4.6,7.52,0,2-.87,3.34-2.55,3.69v1.09H113.1V157c-1.7-.35-2.55-1.65-2.55-3.69v-1h2.22v1.18c0,1.07.48,1.46,1.23,1.46s1.22-.39,1.22-1.46c0-3.08-4.61-3.23-4.61-7.52C110.61,143.92,111.45,142.63,113.1,142.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.5,279.5s1,5.5,2.25,7.5,4.75,4.25,5,8.5a82.85,82.85,0,0,1,0,8.5s10.75,6.5,19.5,11a106.79,106.79,0,0,0,16.25,6.75L237,342.5s-26.5-18.5-32.75-24.25-12-12.25-13-12.5-9-11.25-9.25-12.5,3.75-3.75,5-3.5,2.75-2.75,3.5-5.25.75-5.5,2.5-5.5A14.62,14.62,0,0,1,196.5,279.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,279.74l30.71,31.15a2.76,2.76,0,0,0,3.48.37l7.9-5.22a2.75,2.75,0,0,0,.49-4.17l-28-30a2.74,2.74,0,0,0-3-.69l-10.6,4.07A2.75,2.75,0,0,0,160.2,279.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,381.39A102.52,102.52,0,0,0,303.44,376c.64-8.9,1.06-19.63,1.06-23.53,0-6.75,5.75-31.75,8.75-45.25s-1-28.5-4.5-42.75-17.25-24-17.25-24l-34,16.25s-25.5,22.75-27.75,35,6.75,23.5,6.75,26.25C236.5,320.27,227.11,364.53,223.85,381.39Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.14,318.18s12.89-9.54,13.92-10.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.56,
    y1: 322.56,
    x2: 303.74,
    y2: 319.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.25 238 255.25 244.25 282.25 226.25 275 216.25 251 236.25 252.25 238",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.9,223.65,252.78,242a3.85,3.85,0,0,0-1.34,4.64l5.31,12.78a3.34,3.34,0,0,0,4.83,1.57l30.3-18.55a3.35,3.35,0,0,0,.94-4.85L283,224.3A3,3,0,0,0,278.9,223.65Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,183.52s.86,12,3.44,17.17,6.87,10.31,5.58,12.45-3.44,7.3-.43,9.45a8.08,8.08,0,0,0,5.58,1.72s7.43,18,12.55,19c8.89,1.81,22.66-14.29,24-14.72s12.45-8.16,13.31-18-4.3-24-8.59-25.76-13.31.42-21-2.58S215.29,171.92,213.57,183.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.31,205l1.29,3.86a7.37,7.37,0,0,0,7.73-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,199.07s2.22-3.84,9.5-1.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,227a8.33,8.33,0,0,0,4-1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.57,158.61s-8.59,9-7.3,16.32S214,189.1,219.15,189.1s8.16-1.29,14.6-1.29,13.31,4.72,15.89,7.3,6,6,8.16,2.58.86-6.44,9.44-5.59,6.87,14.17,3.87,20.61-5.15,9.88-8.59,9.88-8.16-2.15-5.58,1.72,10.3,12.88,27.91,9.44,23.18-18,23.18-26.62-6-21.47-10.3-30.48-12.88-27.91-33.92-33.92S219.15,144.44,210.57,158.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,200.88s-.4-8.48,4.65-10.1,10.1,1.42,10.31,7.48-.61,12.32-2.83,14.55-8.29.4-8.29.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,263s-12.25,9-14.75,20-8.5,42.25-8.5,42.25-4-.5-4,.5a18.86,18.86,0,0,1-1,3.75s-3.25,0-3.5,1.25-27-12.5-33.75-17S195.75,303,194.25,301a113,113,0,0,0-9.5-10.75c-2.75-2.5-8.25-6-9.25-6.75s-2.5-7.25-4.75-6.25-1.75,5.5-.75,7.25,5,9,5,9-8.5.75-10.25,2-2.75,5.5-.75,7,6.5,2,6.5,2,1.25,6.25,3.75,8,6.75,3.5,9,4.5,10,1.25,10,1.25,10.5,11.75,17.75,19S246.75,365,251,366.5s9.25-1.75,11-4.25,31-43.75,38-57.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,263s-12.25,9-14.75,20-8.5,42.25-8.5,42.25-4-.5-4,.5a18.86,18.86,0,0,1-1,3.75s-3.25,0-3.5,1.25c-.12.59-6.08-2.14-13.08-5.66L220.6,345.36c11.25,8.81,27.29,20,30.4,21.14,4.25,1.5,9.25-1.75,11-4.25s32.38-44.64,40-59",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,282s-3.25,8.75-4.75,9.5-3,.5-4-1.75,2.25-9.25,2.25-9.25,1-3.25,4-3.25,3.25,2.25,3.25,2.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.807ab3a8133a3eb6414a996d2e95ad71.svg";
export { ForwardRef as ReactComponent };